import axios from 'axios';
import DBService from '~/settings/__modules__/utils/DBservice';

export const AppData = {
  DomainConfig: {
    supportExternalRoom: false,
  },
  UserOptions: {
    options: [],
  },
  supportStampSuggestion: false,
  StampSuggestionExist: false,
  CurrentUser: {},
};

export const UserOptionName = {
  Is_Notify: 'WebMessage.is.notify',
  Send_Msg_Key: 'WebMessage.Send.Msg.key',
  FONT_SIZE_STYLE: 'FONT_SIZE_STYLE',
  Smart_Translate: 'smartTranslate',
  STAMPSUGGESION_LANG_OPTION: 'StampSuggestion.lang.options',
  STAMPSUGGESION_ENABLE: 'StampSuggestion.enable',
  STAMPSUGGESION_DONOT_SHOW_GUIDE: 'StampSuggestion.do.not.show.guild',
  STAMPSUGGESION_DONT_SHOW_DOWNLOAD_OPTION:
    'StampSuggestion.do.not.show.download.guild',
  Auto_Reply: 'autoResponse',
  Auto_Reply_Internal: 'autoResponseForInternal',
  DefaultChannelBgColor: 'defaultChannelBgColor',
};

const OptionDefaultConfig = {};
OptionDefaultConfig[UserOptionName.Send_Msg_Key] = '';
OptionDefaultConfig[UserOptionName.Smart_Translate] = '';
OptionDefaultConfig[UserOptionName.FONT_SIZE_STYLE] = 'font_medium';
OptionDefaultConfig[UserOptionName.STAMPSUGGESION_LANG_OPTION] =
  'ja_JP,zh_CN,zh_TW,ko_KR,en_US';
OptionDefaultConfig[UserOptionName.STAMPSUGGESION_DONT_SHOW_DOWNLOAD_OPTION] =
  false;
OptionDefaultConfig[UserOptionName.STAMPSUGGESION_DONOT_SHOW_GUIDE] = false;
OptionDefaultConfig[UserOptionName.STAMPSUGGESION_ENABLE] = 'true';
OptionDefaultConfig[UserOptionName.Auto_Reply] = JSON.stringify({
  enable: false,
  enableHoliday: false,
  content: '',
  timeSettings: [],
});
OptionDefaultConfig[UserOptionName.Auto_Reply_Internal] =
  OptionDefaultConfig[UserOptionName.Auto_Reply];
OptionDefaultConfig[UserOptionName.DefaultChannelBgColor] = '#FFFFFFFF';

const IndexDBStatus = {
  Exist: 1,
  NotExists: 0,
  NotSupport: -1,
};

export class CommonService {
  static changes = [];

  static async init() {
    let optionNames = [
      UserOptionName.Is_Notify,
      UserOptionName.Send_Msg_Key,
      UserOptionName.FONT_SIZE_STYLE,
      UserOptionName.STAMPSUGGESION_LANG_OPTION,
      UserOptionName.STAMPSUGGESION_ENABLE,
      UserOptionName.Auto_Reply,
      UserOptionName.Auto_Reply_Internal,
      UserOptionName.STAMPSUGGESION_DONOT_SHOW_GUIDE,
      UserOptionName.STAMPSUGGESION_DONT_SHOW_DOWNLOAD_OPTION,
      UserOptionName.Smart_Translate,
      UserOptionName.DefaultChannelBgColor,
    ];
    await CommonService.getUserOptions(optionNames);
    await CommonService.getAdminFunction();
    const { support, result } = await CommonService.checkSupportAndExist();
    AppData.supportStampSuggestion = support;
    AppData.StampSuggestionExist = result === IndexDBStatus.Exist;
  }

  static async getUserOptions(optionNames) {
    try {
      const responseItem = await axios({
        method: 'post',
        url: '/p/oneapp/client/api/getUserOptions',
        data: {
          optionNames: optionNames,
        },
      });

      const response = responseItem.data;
      const userOptions = AppData.UserOptions;

      if (!userOptions.options) {
        userOptions.options = [];
      }
      if (response.code === 200) {
        if (response.userOptions && response.userOptions.length) {
          response.userOptions.forEach((item) => {
            let option = userOptions.options.find(
              (child) => child.optionName == item.optionName,
            );
            if (option) {
              option.optionValue = item.optionValue;
            } else {
              userOptions.options.push(item);
            }
          });
        }
        return true;
      }
    } catch (error) {
      //empty
      console.error(error);
    }
    return false;
  }

  static async checkSupportAndExist() {
    return await DBService.supportAndExist();
  }

  static async getAdminFunction() {
    const userNo = AppData.CurrentUser.userId;
    const functionCode = 'F027,F030';
    const response = await axios({
      method: 'get',
      url:
        '/p/admin/api/functionauth/check/function?functionCode=' +
        functionCode +
        '&userIdNo=' +
        userNo,
    });
    CommonService.readAdminConfig(response.data);
  }

  static readAdminConfig(responseItem) {
    const data = responseItem.data;
    const DomainConfig = AppData.DomainConfig;

    if (!data) return;

    data.forEach((item) => {
      switch (item.functionCode) {
        case 'F027': {
          let supportExternalRoom = item.functionAuth;
          if (item.functionValue) {
            const temps = item.functionValue.split(',');
            const supportLine = temps.indexOf('line') > -1;
            const supportWorksAt = temps.indexOf('worksat') > -1;
            DomainConfig.supportLine = supportLine;
            DomainConfig.supportWorksAt = supportWorksAt;
          } else {
            supportExternalRoom = false;
          }
          DomainConfig.supportExternalRoom = supportExternalRoom;
          break;
        }
        default:
          break;
      }
    });
  }

  static async save(onlySaveChanges = false) {
    let options = onlySaveChanges ? this.changes : AppData.UserOptions.options;
    let payload = { userOptions: [] };
    options.forEach((x) => {
      let obj = {
        optionName: x.optionName,
        optionValue: x.optionValue,
      };
      if (['smartTranslate', 'defaultChannelBgColor'].includes(x.optionName)) {
        payload.syncMode = true;
      }
      if (x.optionName === UserOptionName.Auto_Reply) {
        return;
      }
      payload.userOptions.push(obj);
    });
    this.changes = [];
    return await axios.post(
      '/p/oneapp/client/api/setUserOptions',
      `payload=${JSON.stringify(payload)}`,
      { serialize: true },
    );
  }

  static getOptionValue(name) {
    let options = AppData.UserOptions.options;
    if (options) {
      const result = options.find((x) => x.optionName === name);
      if (result) {
        return result.optionValue;
      } else {
        return OptionDefaultConfig[name];
      }
    }
  }

  static getOptionValueAsBoolean(name) {
    const value = CommonService.getOptionValue(name);
    if (value === 'true' || value === '1') {
      return true;
    }
    return false;
  }

  static setOptionValue(name, value) {
    let optionItem = AppData.UserOptions.options.find(
      (x) => x.optionName === name,
    );

    if (optionItem) {
      optionItem.optionValue = value.toString();
    } else {
      const valStr = value !== null ? value.toString() : '';
      optionItem = {
        optionName: name,
        optionValue: valStr,
      };
      AppData.UserOptions.options.push(optionItem);
    }
    this.changes.push(optionItem);
  }
}
